import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import parse from 'html-react-parser'
import Icon from './Icon'

const CategoryLink = ({ item }) => {
  return (
    <article className="flex w-full mb-0 sm:w-1/2 sm:mb-6">
      <Link
        to={item.slug}
        key={item.title}
        className="flex flex-col w-full p-6 mx-3 mb-6 bg-white rounded-lg cursor-pointer hover:bg-gradient-br-primary shadow-card hover:shadow-cardHover hover:text-white sm:mb-0"
      >
        <div className="mb-2">
          <h3 className="text-lg font-semibold">{item.title}</h3>
        </div>
        <div className="flex-auto mb-6">{parse(item.blurb)}</div>
        <div className="flex items-center">
          <span className="flex items-center h-8 px-6 mr-2 text-sm font-semibold rounded-full bg-primary-lighter text-body">
            Find out more
          </span>
          <div className="flex items-center justify-center w-8 h-8 rounded-full text-secondary bg-primary-lighter">
            <Icon icon="forwardArrow" className="w-3 h-3 fill-current" />
          </div>
        </div>
      </Link>
    </article>
  )
}

CategoryLink.propTypes = {
  item: PropTypes.object,
  category: PropTypes.string,
}

export default CategoryLink
